var React = require('react');

function Mailto (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_987_156187","style":{"maskType":"luminance"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 17V24H0V0H24V17H20Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0_987_156187)","key":1},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 5H22V19H2V5ZM4 7V17H20V7H4Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.3333 11H12.6667L20.4 5.2L21.6 6.8L13.3333 13H10.6667L2.4 6.8L3.6 5.2L11.3333 11Z","fill":"currentColor","key":1})])]);
}

Mailto.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Mailto;

Mailto.default = Mailto;
